const ONES = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen',
  'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
const TENS = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

const under1000 = (n) => {
  const h = Math.floor(n / 100), rest = n % 100;
  const t = rest < 20 ? (rest || !h ? ONES[rest] : '') : TENS[Math.floor(rest / 10)] + (rest % 10 ? `-${ONES[rest % 10]}` : '');
  return [h ? `${ONES[h]} Hundred` : '', t].filter(Boolean).join(' ');
};

export const amountWords = (amount) => {
  const v = Math.round(Math.max(0, Number(amount) || 0) * 100) / 100;
  let d = Math.floor(v);
  const cents = Math.round((v - d) * 100);
  const parts = [];
  [[1e9, 'Billion'], [1e6, 'Million'], [1e3, 'Thousand']].forEach(([u, w]) => {
    if (d >= u) { parts.push(`${under1000(Math.floor(d / u))} ${w}`); d %= u; }
  });
  if (d || !parts.length) parts.push(under1000(d));
  return `${parts.join(' ')} and ${String(cents).padStart(2, '0')}/100 Dollars`;
};

// Map Write-a-Check data into the Treasury Check face shape
export const toTreasuryFace = ({ number, date, amount, payee, payeeAddress, memo, drawer, wallet, hash, network, settle }) => ({
  settle_line: settle,
  check_no: number,
  date,
  amount,
  amount_words: amountWords(amount),
  payee: { name: payee },
  payee_address: payeeAddress || '',
  payload: { memo, parties: { seller: { name: drawer } } },
  reference: {},
  network,
  issuer_seal: hash || '',
  contract: wallet,
  payload_hash: hash,
});
